import { render, staticRenderFns } from "./xeChartDonut.vue?vue&type=template&id=823031fa&scoped=true"
import script from "./xeChartDonut.vue?vue&type=script&lang=js"
export * from "./xeChartDonut.vue?vue&type=script&lang=js"
import style0 from "./xeChartDonut.vue?vue&type=style&index=0&id=823031fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823031fa",
  null
  
)

export default component.exports